export const WIDGETS_LIST_DROPPABLE_CONTAINER = 'widgets-list';
